export default __webpack_public_path__ + "static/media/Beard_10_C2.e00462fd.svg";